import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const StyledMenuBox = styled(Box)`
    width: 15%;
    padding: 37px 0px 37px 0px;
    border-right: 1px solid ${({ theme }) => theme.palette.blue.darkest};
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
`;
